import { render, staticRenderFns } from "./MagicLinkHandler.vue?vue&type=template&id=0c5be2e8&"
import script from "./MagicLinkHandler.vue?vue&type=script&lang=js&"
export * from "./MagicLinkHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports